/* Paneles de filtro/orden y agotados al final.
   OJO: Shopify pagina del lado del servidor, así que este reordenamiento solo alcanza a los
   productos de la página ya cargada. Para toda la colección hace falta el filtro nativo de
   disponibilidad de Shopify. Está anotado en el plan a propósito. */
(function () {
  function init() {
    // Paneles
    document.querySelectorAll('[data-ff-abrir]').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = document.querySelector('[data-ff-panel="' + b.dataset.ffAbrir + '"]');
        if (p) p.hidden = false;
      });
    });
    document.querySelectorAll('[data-ff-cerrar]').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = b.closest('[data-ff-panel]');
        if (p) p.hidden = true;
      });
    });

    // Agotados al final (solo dentro de esta página)
    var grid = document.querySelector('[data-ff-grid]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.children);
    var hay = items.filter(function (i) { return i.dataset.disponible === '1'; });
    var no = items.filter(function (i) { return i.dataset.disponible !== '1'; });
    if (!no.length) return;
    hay.concat(no).forEach(function (i) { grid.appendChild(i); });
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
